import { advancedChartPreset } from './advanced'
import { dynamicChartPreset } from './dynamic'
import { simpleChartPreset } from './simple'

export const chartPresets = {
  dynamic: dynamicChartPreset,
  simple: simpleChartPreset,
  advanced: advancedChartPreset
}
